import React from 'react';
import { Text, StyleSheet, View, TouchableOpacity, Platform } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import { Button, BackgroundGradient, Loader, Validate, TextInputContainer, AddressPicker, YesNoToggle, Alert, ToolTipWrapper } from '../../components';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import SelectBox from 'react-native-multi-selectbox';
import Constants from 'expo-constants';
import * as Localization from 'expo-localization';
import { businessStructureOptions, addressToolTip } from '../../constants/Arrays';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { FontAwesome5, Ionicons } from '@expo/vector-icons';
import { useLinkTo } from '@react-navigation/native';
import { stripNonNumeric } from '../../utils/Functions';

const AccountType = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [alertOptions, setAlertOptions] = React.useState({});
  const [localStructure, setLocalStructure] = React.useState({
    item: 'Sole Proprietorship',
    id: 1,
  },);
  const [businessNumberLabel, setBusinessNumberLabel] = React.useState('Business Number / Employer Identification Number (EIN)');

  const linkTo = useLinkTo();

  React.useEffect(() => {
    console.log('Localization.region: ', Localization.region);
    // if(Localization.region === 'US'){
    //   setBusinessNumberLabel('Employer Identification Number (EIN)');
    // }
    checkSignUpProgress();
  }, []);

  const checkSignUpProgress = (route) => {
    if (!props.signUpProgress.Terms) {
      linkTo('/login');
    }
  }

  const defaultIsInvalid = { businessNumber: false, legalName: false, legalAddress: false };
  const [isInvalid, setIsInvalid] = React.useState(defaultIsInvalid);
  let textInputs = {
    businessNumber: React.useRef(null),
    legalName: React.useRef(null),
    legalAddress: React.useRef(null),
  };
  const isInvalidAddress = () => {
    setIsInvalid(prevState => { return { ...prevState, legalAddress: false } });
  }

  const insets = useSafeAreaInsets();

  const confirmAccountType = async () => {
    console.log('confirmTerms', props);
    if(props.isContractor){
      if(!checkAccountType()){
        return false;
      }
      if(props.legalAddress){
        props.setContractorAddress(props.legalAddress);
        props.setContractorStreetId(props.legalStreetId);
        props.setContractorStreetNumber(props.legalAddressNumber);
        props.setContractorAddressUnit(props.legalAddressUnit);
        props.setContractorCountry(props.legalCountry);
        props.setContractorZipCode(props.legalZipCode);
      }
    }
    props.completeStep('AccountType');
  }
  const checkAccountType = () => {
    if (props.structure === 'Individual'){ return true; } //nothing required
    // businessNumber
    if (!Validate.BusinessNumber(props.businessNumber)) {
      setIsInvalid(prevState => { return { ...prevState, businessNumber: true } });
      textInputs.businessNumber.current.focus();
      return;
    }
    // legalName
    if (!Validate.Blank(props.legalName)) {
      setIsInvalid(prevState => { return { ...prevState, legalName: true } });
      textInputs.legalName.current.focus();
      return;
    }
    // address
    if(!props.legalAddressNumber){
      setAlertOptions({ visible: true, title: 'Error', message: 'Address is required.', });
      return;
    }

    return true;
  }
  const onChangeBusinessNumber = (input) => {
    input = stripNonNumeric(input);
    if (isInvalid.businessNumber && Validate.BusinessNumber(input)) {
      setIsInvalid(prevState => { return { ...prevState, businessNumber: false } });
    }
    props.setBusinessNumber(input);
  };
  const onChangeLegalName = (input) => {
    if (isInvalid.legalName && Validate.Blank(input)) {
      setIsInvalid(prevState => { return { ...prevState, legalName: false } });
    }
    props.setLegalName(input);
    props.setCompanyName(input);
  };

  // structure
  const selectStructure = (s) => {
    setLocalStructure(s);
    props.setStructure(s.item);
    if(s.item === 'Sole Proprietorship'){
      props.setPreferredPaymentIdentity('personal');
    }else{
      props.setPreferredPaymentIdentity('company');
    }
  }

  const goBack = () => {
    if (props.navigation.canGoBack()) {
      props.navigation.goBack();
    } else {
      linkTo('/signup/terms');
    }
  }

  return (
    <View style={CS.container}>
      <BackgroundGradient />
      <Loader animating={loading} />
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <KeyboardAwareScrollView keyboardShouldPersistTaps='handled' style={styles.container} contentContainerStyle={[styles.innerContainer, { paddingTop: insets.top, paddingBottom: insets.bottom }]}>
        <TouchableOpacity onPress={goBack} style={{ marginTop: 10, marginBottom: 20, justifyContent: 'center' }}>
          <FontAwesome5 name="arrow-left" size={24} color="white" style={{ position: 'absolute' }} />
          <Text style={[CS.mediumTitle, CS.lightText, CS.centerText, { marginVertical: 0 }]}>Account Type</Text>
        </TouchableOpacity>
        <View style={styles.switchContainer}>
          <YesNoToggle setValue={props.setIsContractor} value={props.isContractor} text='Are you a contractor?' />
        </View>

        {/* contractor only stuff */}
        {props.isContractor && 
        <>
          <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Business Structure</Text>
          <View style={{ marginBottom: props.structure === 'Individual' ? 10 : 0 }}>
            <SelectBox
              label=""
              options={businessStructureOptions}
              value={localStructure}
              onChange={selectStructure}
              hideInputFilter={true}
              arrowIconColor={Colors.lightGrey}
              labelStyle={{ display: 'none', }}
              optionsLabelStyle={{ color: Colors.lightText, padding: 8, backgroundColor: Colors.textInputBackground }}
              selectedItemStyle={{ color: Colors.lightText }}
              containerStyle={{ borderWidth: 1, borderRadius: 10, backgroundColor: Colors.textInputBackground, padding: 8, height: 44, borderColor: Colors.lightBlue, alignItems: 'center' }}
              optionContainerStyle={{ borderWidth: 1, borderColor: Colors.lightBlue, padding: 0, paddingVertical: 0, paddingRight: 0, backgroundColor: Colors.textInputBackground, borderRadius: 0, width: '96%', marginLeft: '2%', flexDirection: 'column', alignItems: 'stretch' }}
              listEmptyLabelStyle={{ color: Colors.lightText, }}
            />
          </View>
          {props.structure !== 'Individual'
          ?
          <>
            <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel, { marginTop: 20 }]}>{businessNumberLabel}</Text>
            <TextInputContainer
              // iconName='briefcase'
              // placeholder='Business Number(CA) / Tax ID(US)'
              textContentType='none'
              onChangeText={(t) => onChangeBusinessNumber(t)}
              inputRef={textInputs.businessNumber}
              keyboardType='numeric'
              // autoFocus={true} 
              isInvalid={isInvalid.businessNumber}
              value={props.businessNumber}
              autoCapitalize='none'
              autoCompleteType='off'
              autoCorrect={false}
              returnKeyType='done'
              enablesReturnKeyAutomatically={true}
              onSubmitEditing={() => textInputs.legalName.current.focus()}
              maxLength={9}
            />
            <Text style={[CS.smallText, CS.lightBlueText, styles.inputLabel]}>Legal Business Name</Text>
            <TextInputContainer
              // iconName='building-o'
              // placeholder='Business Name'
              textContentType='organizationName'
              onChangeText={(t) => onChangeLegalName(t)}
              inputRef={textInputs.legalName}
              keyboardType='default'
              // autoFocus={true} 
              isInvalid={isInvalid.legalName}
              value={props.legalName}
              autoCapitalize='words'
              autoCompleteType='off'
              autoCorrect={false}
              returnKeyType='next'
              enablesReturnKeyAutomatically={true}
              onSubmitEditing={() => textInputs.legalAddress.current.focus()}
            />
            <View style={[CS.rowContainer, styles.inputLabel]}>
              <Text style={[CS.smallText, CS.lightBlueText]}>Business Address</Text>
              <ToolTipWrapper
                text={addressToolTip}
              />
            </View>
            <AddressPicker
              // iconName='home'
              // placeholder='Legal Business Address'
              innerPlaceholder='10-1000 Main St. Toronto, ON'
              value={props.legalAddress}
              offsetTop={Constants.statusBarHeight}
              setAddress={props.setLegalAddress}
              setStreetId={props.setLegalStreetId}
              setZipCode={props.setLegalZipCode}
              setStreetNumber={props.setLegalAddressNumber}
              setAddressUnit={props.setLegalAddressUnit}
              setCountry={props.setLegalCountry}
              // setLongitude={props.setLongitude}
              // setLatitude={props.setLatitude}
              inputRef={textInputs.legalAddress}
              setIsInvalid={isInvalidAddress}
            />
          </>
          : null
          }
          {(props.structure === 'Corporation' || props.structure === 'Partnership') ?
            <TouchableOpacity activeOpacity={0.6} style={[CS.rowContainer, styles.checkboxContainer]} onPress={() => { props.setLegallyBindCompany(!props.legallyBindCompany)}}>
              <Ionicons name={props.legallyBindCompany ? 'checkbox-outline' : 'ios-square-outline'} size={36} color={props.legallyBindCompany ? Colors.yellow : Colors.lightBlue} style={styles.checkbox} />
              <Text style={[CS.smallText, CS.lightBlueText]}>I have the legal authority to bind the {props.structure.toLowerCase()}</Text>
            </TouchableOpacity>
          : null}
        </>
        }
        {props.isContractor &&
          <Text style={[CS.miniText, CS.lightBlueText, CS.italicText, { marginBottom: 20}]}>* The information on this screen is private</Text>
        }
        <View style={{ marginTop: Platform.OS === 'web' ? 0 : 'auto' }}>
        {/* <View style={{ marginTop: 'auto' }}> */}
          <Button text='Continue' onPress={() => confirmAccountType} disabled={(props.structure === 'Corporation' || props.structure === 'Partnership') && !props.legallyBindCompany} />
        </View>
      </KeyboardAwareScrollView>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginVertical: 10,
    // backgroundColor: 'pink',
  },
  innerContainer: {
    width: '100%',
    // backgroundColor: 'blue',
    maxWidth: Platform.OS === 'web' ? 768 : '100%',
    justifyContent: Platform.OS === 'web' ? 'center' : 'flex-start',
    flexGrow: 1,
    alignSelf:'center',
  },
  switchContainer: {
    marginVertical: 20,
  },
  inputLabel: {
    marginBottom: 5,
  },
  checkboxContainer: {
    marginBottom: 20,
  },
  checkbox: {
    marginRight: 5,
  },
});

export default React.memo(AccountType);